import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type ShareLinkType } from './useTrackBrandContextSelected';
import META from './useTrackCoverImageAdded.meta';

export type UseTrackCoverImageAddedParams = {
  type: ShareLinkType;
};

export const useTrackCoverImageAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackCoverImageAdded = useCallback(
    (params: UseTrackCoverImageAddedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCoverImageAdded };
};
